/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AssigneeOptions_ProjectFragmentDoc } from '../Tasks.generated.js';
import { TasksTimesheetForm_ItemFragmentDoc } from '../components/TasksTimesheetForm.generated.js';
import { WorkSession__EntityFragmentDoc } from '../../projects/boxes/ProjectOverviewWorkSessionsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TasksTimesheetBoxQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type TasksTimesheetBoxQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, viewerPermissions: Array<Types.PermissionName>, state: Types.ProjectStateMachineStatus, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, membershipStatus: Types.OrganisationMembershipStatus }, roles: Array<{ __typename: 'ProjectRole', id: string, internalName: string }> }> } | null } };

export type TasksTimesheetBox_ItemFragment = { __typename: 'Item', id: string, canBeWorkedOn: boolean, deletedAt?: any | null, title: string, timeTrackingRequired: boolean, isDone: boolean, photoApprovalRequired: boolean, qaApprovalRequired: boolean, approvalRequired: boolean, workSessionsDuration: number, priority: number, docId: string, type: Types.ItemType, rank: number, level: number, parentId?: string | null, isRootItem: boolean, pathForPdf: string, pathSortable: string, isHidden: boolean, isPriceHidden: boolean, isParentDecisionPreselected: boolean, isParentDecisionNotPreselected: boolean, isParentContingencyNotPreselected: boolean, binding: Types.ItemBinding, decisionIsContingentItem: boolean, decisionSubitemsPreselection: Array<string>, decisionBehaviorOfSubitems: Types.DecisionBehaviorOfSubitems, decisionContingentItemPreselection?: boolean | null, isExplicitHidden: boolean, childrenVisibility: Types.ItemChildrenVisibility, isItemEliminated: boolean, hasChildren: boolean, dueDate?: any | null, doneDate?: any | null, isVisibleToOtherSide: boolean, isQaApproved?: boolean | null, isApproved?: boolean | null, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null, assignee?: { __typename: 'User', id: string, firstname: string, familyname: string } | null, photoApproved?: { __typename: 'AttachmentSnapshot', id: string } | null, proposedCalculation?: { __typename: 'ItemCalculation', materialBuyingPricePerUnit: number, discountRate: number, materialMargin: number, materialPriceDiscountedSubTotal: number, materialPricePerUnit: number, materialPriceSubTotal: number, materialFactor: number, priceNetTotal: number, pricePerUnit: number, priceSubTotal: number, priceTotal: number, priceVatTotal: number, quantity: number, quantityUnit: Types.QuantityUnit, timePerUnit: number, timeTotal: number, workSellingRate: number, workBuyingRate: number, workRate: number, workBuyingPricePerUnit: number, workPriceDiscountedSubTotal: number, workPricePerUnit: number, workPriceSubTotal: number, workFactor: number, vatRate: number } | null };

export type ModifyProjectWorkSessionMutationVariables = Types.Exact<{
  input: Types.ModifyProjectWorkSessionInput;
  assigneeId: Types.Scalars['ID']['input'];
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type ModifyProjectWorkSessionMutation = { modifyProjectWorkSession: { __typename: 'ModifyProjectWorkSessionResult', project: { __typename: 'Project', id: string, workSessions: Array<{ __typename: 'WorkSession', id: string, from?: any | null, till?: any | null, date?: any | null, duration?: number | null, isBreak: boolean, isCorrection: boolean, itemId?: string | null }> } } };

export type ModifyMyProjectWorkSessionMutationVariables = Types.Exact<{
  input: Types.ModifyMyProjectWorkSessionInput;
  assigneeId: Types.Scalars['ID']['input'];
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type ModifyMyProjectWorkSessionMutation = { modifyMyProjectWorkSession: { __typename: 'ModifyProjectWorkSessionResult', project: { __typename: 'Project', id: string, workSessions: Array<{ __typename: 'WorkSession', id: string, from?: any | null, till?: any | null, date?: any | null, duration?: number | null, isBreak: boolean, isCorrection: boolean, itemId?: string | null }> } } };

export const TasksTimesheetBox_ItemFragmentDoc = gql`
    fragment TasksTimesheetBox_Item on Item {
  id
  canBeWorkedOn
  deletedAt
  ...TasksTimesheetForm_Item
}
    ${TasksTimesheetForm_ItemFragmentDoc}`;
export const TasksTimesheetBoxDocument = gql`
    query TasksTimesheetBox($projectId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        viewerPermissions
        state
        ...AssigneeOptions_Project
      }
    }
  }
}
    ${AssigneeOptions_ProjectFragmentDoc}`;

/**
 * __useTasksTimesheetBoxQuery__
 *
 * To run a query within a React component, call `useTasksTimesheetBoxQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksTimesheetBoxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksTimesheetBoxQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTasksTimesheetBoxQuery(baseOptions: Apollo.QueryHookOptions<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables> & ({ variables: TasksTimesheetBoxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>(TasksTimesheetBoxDocument, options);
      }
export function useTasksTimesheetBoxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>(TasksTimesheetBoxDocument, options);
        }
export function useTasksTimesheetBoxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>(TasksTimesheetBoxDocument, options);
        }
export type TasksTimesheetBoxQueryHookResult = ReturnType<typeof useTasksTimesheetBoxQuery>;
export type TasksTimesheetBoxLazyQueryHookResult = ReturnType<typeof useTasksTimesheetBoxLazyQuery>;
export type TasksTimesheetBoxSuspenseQueryHookResult = ReturnType<typeof useTasksTimesheetBoxSuspenseQuery>;
export type TasksTimesheetBoxQueryResult = Apollo.QueryResult<TasksTimesheetBoxQuery, TasksTimesheetBoxQueryVariables>;
export const ModifyProjectWorkSessionDocument = gql`
    mutation ModifyProjectWorkSession($input: ModifyProjectWorkSessionInput!, $assigneeId: ID!, $date: Date) {
  modifyProjectWorkSession(input: $input) {
    project {
      id
      workSessions(assigneeId: $assigneeId, date: $date) {
        id
        ...WorkSession__Entity
      }
    }
  }
}
    ${WorkSession__EntityFragmentDoc}`;
export type ModifyProjectWorkSessionMutationFn = Apollo.MutationFunction<ModifyProjectWorkSessionMutation, ModifyProjectWorkSessionMutationVariables>;

/**
 * __useModifyProjectWorkSessionMutation__
 *
 * To run a mutation, you first call `useModifyProjectWorkSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyProjectWorkSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyProjectWorkSessionMutation, { data, loading, error }] = useModifyProjectWorkSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      assigneeId: // value for 'assigneeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useModifyProjectWorkSessionMutation(baseOptions?: Apollo.MutationHookOptions<ModifyProjectWorkSessionMutation, ModifyProjectWorkSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyProjectWorkSessionMutation, ModifyProjectWorkSessionMutationVariables>(ModifyProjectWorkSessionDocument, options);
      }
export type ModifyProjectWorkSessionMutationHookResult = ReturnType<typeof useModifyProjectWorkSessionMutation>;
export type ModifyProjectWorkSessionMutationResult = Apollo.MutationResult<ModifyProjectWorkSessionMutation>;
export type ModifyProjectWorkSessionMutationOptions = Apollo.BaseMutationOptions<ModifyProjectWorkSessionMutation, ModifyProjectWorkSessionMutationVariables>;
export const ModifyMyProjectWorkSessionDocument = gql`
    mutation ModifyMyProjectWorkSession($input: ModifyMyProjectWorkSessionInput!, $assigneeId: ID!, $date: Date) {
  modifyMyProjectWorkSession(input: $input) {
    project {
      id
      workSessions(assigneeId: $assigneeId, date: $date) {
        id
        ...WorkSession__Entity
      }
    }
  }
}
    ${WorkSession__EntityFragmentDoc}`;
export type ModifyMyProjectWorkSessionMutationFn = Apollo.MutationFunction<ModifyMyProjectWorkSessionMutation, ModifyMyProjectWorkSessionMutationVariables>;

/**
 * __useModifyMyProjectWorkSessionMutation__
 *
 * To run a mutation, you first call `useModifyMyProjectWorkSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyMyProjectWorkSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyMyProjectWorkSessionMutation, { data, loading, error }] = useModifyMyProjectWorkSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *      assigneeId: // value for 'assigneeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useModifyMyProjectWorkSessionMutation(baseOptions?: Apollo.MutationHookOptions<ModifyMyProjectWorkSessionMutation, ModifyMyProjectWorkSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyMyProjectWorkSessionMutation, ModifyMyProjectWorkSessionMutationVariables>(ModifyMyProjectWorkSessionDocument, options);
      }
export type ModifyMyProjectWorkSessionMutationHookResult = ReturnType<typeof useModifyMyProjectWorkSessionMutation>;
export type ModifyMyProjectWorkSessionMutationResult = Apollo.MutationResult<ModifyMyProjectWorkSessionMutation>;
export type ModifyMyProjectWorkSessionMutationOptions = Apollo.BaseMutationOptions<ModifyMyProjectWorkSessionMutation, ModifyMyProjectWorkSessionMutationVariables>;